import styled from '@emotion/styled'
import React, { useState } from 'react'

import VideoPlayer from './video-player'

const VideoCTA = ({
  className,
  buttonText = 'Watch the video',
  ctaText,
  ...passThrough
}) => {
  const [showVideo, setShowVideo] = useState(false)
  const toggleShowVideo = () => {
    setShowVideo(!showVideo)
  }
  return (
    <div className={className}>
      {ctaText && <div className="heading--h4 microcopy">{ctaText}</div>}
      <button onClick={toggleShowVideo} className="watchButton button">
        {buttonText}
      </button>
      {showVideo && (
        <PlayerModal close={toggleShowVideo}>
          <VideoPlayer playing {...passThrough} />
        </PlayerModal>
      )}
    </div>
  )
}

const PlayerModal = ({ children, close }) => (
  <Modal>
    <div className="modal__content">
      <button className="modal__closeButton" onClick={close}>
        Close
      </button>
      {children}
    </div>
  </Modal>
)

const Modal = styled.div`
  position: fixed;
  z-index: 999;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.85);
  display: flex;
  justify-content: center;
  align-items: center;
  animation: fadeIn 0.3s ease;
  animation-fill-mode: both;

  @keyframes fadeIn {
    from {
      opacity: 0;
    }
  }

  @keyframes slideUp {
    from {
      opacity: 0;
      transform: translateY(100%);
    }
  }

  .modal {
    &__content {
      position: relative;
      z-index: 999;

      max-width: 100%;
      width: 800px;
    }
    &__closeButton {
      position: relative;
      top: -32px;
      float: right;
      background: 0;
      border: 0;
      color: #fff;
      margin-bottom: 8px;
      animation: slideUp 0.3s 0.5s ease;
      animation-fill-mode: both;

      &::before {
        content: '× ';
      }
    }
  }
`

export default styled(VideoCTA)`
  display: flex;
  flex-flow: row wrap;
  justify-content: center;
  align-items: center;

  margin-top: 24px;

  > * {
    margin-top: 4px;
    margin-bottom: 4px;
  }

  color: #fff;

  .microcopy {
    font-size: 2rem;
    margin-left: 4px;
    margin-right: 16px;
    white-space: nowrap;
  }

  .watchButton {
    padding-left: 16px;
    padding-right: 16px;
  }
`
